import React from 'react'
import Layout from '../../../components/Layout/Layout'
import { Link } from 'react-router-dom'

const stores = [
  { label: 'Conference Store', path: '/admin/store/conference' },
  { label: 'ER Shop', path: '/admin/store/er', disabled: true },
  { label: 'SP', path: '/admin/store/sp', disabled: true },
]

const AdminExtraStore = () => {
  return (
    <Layout title={'Extra Store Import'}>
      <div className='container-fluid px-3 px-md-4 py-4'>
        <div className='row g-4'>
          {stores.map((store) => {
            const body = (
              <div className='card-body d-flex align-items-center justify-content-center text-center py-3'>
                <div className='fw-semibold'>{store.label}</div>
              </div>
            )

            return (
              <div className='col-6 col-md-4 col-xl-3' key={store.label}>
                {/* A disabled tile renders as a plain card, not a Link - the
                    route stays reachable by URL, but nothing here offers it. */}
                {store.disabled ? (
                  <div
                    className='card h-100 stock-category-tile stock-category-tile-disabled'
                    aria-disabled='true'
                  >
                    {body}
                  </div>
                ) : (
                  <Link
                    to={store.path}
                    className='card h-100 text-decoration-none stock-category-tile'
                  >
                    {body}
                  </Link>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </Layout>
  )
}

export default AdminExtraStore
